module.exports = __webpack_public_path__ + "img/47.6d309939.jpg";